import React, { type ComponentPropsWithoutRef } from 'react';
import PerformanceMark from '@atlassian/jira-common-performance/src/set-performance-mark.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { ErrorFlagRenderer } from '@atlassian/jira-error-boundary-flag-renderer/src/ErrorBoundaryFlag.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type CustomFieldContextDeleteModal from './ui/CustomFieldContextDeleteModal.tsx';

const LOAD_START_MARK_KEY = 'CUSTOM_FIELD_CONTEXT_DELETE_MODAL_LOAD_START_MARK_KEY';

const ErrorComponent = ({ error }: { error: Error }) => (
	<ErrorFlagRenderer
		id="bundle-async-admin-pages-custom-field-context-delete-modal"
		error={error}
	/>
);

const preloadComponent = () =>
	import(
		/* webpackChunkName: "async-admin-pages-custom-field-context-delete-modal" */ './ui/CustomFieldContextDeleteModal.tsx'
	);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyFieldContextDeleteModal = lazy(() => preloadComponent());

export default function AsyncFieldContextDeleteModal(
	props: ComponentPropsWithoutRef<typeof CustomFieldContextDeleteModal>,
) {
	return (
		<JSErrorBoundary
			id="asyncFieldContextDeleteModal"
			packageName="jiraCustomFieldContextDeleteModal"
			teamName="morphinecake"
			fallback={ErrorComponent}
			sendToPrivacyUnsafeSplunk
		>
			<Placeholder
				name="field-context-delete-modal"
				fallback={<PerformanceMark metricKey={LOAD_START_MARK_KEY} />}
			>
				<LazyFieldContextDeleteModal {...props} />
			</Placeholder>
		</JSErrorBoundary>
	);
}
